import { render, staticRenderFns } from "./EmailNotificationAdd.vue?vue&type=template&id=628875a1&"
import script from "./EmailNotificationAdd.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationAdd.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports